export class PdfMergeService {
  constructor() {
    this.worker = null;
  }

  init() {
    if (!this.worker) {
      this.worker = new Worker(process.env.PUBLIC_URL + '/workers/merge.worker.js');
      this.worker.onerror = (e) => {
        console.error('Worker error:', e);
      };
    }
  }

  terminate() {
    if (this.worker) {
      this.worker.terminate();
      this.worker = null;
    }
  }

  async merge(files, jobs) {
    this.init();
    
    return new Promise((resolve, reject) => {
      this.worker.onmessage = (e) => {
        if (e.data.status === 'success') {
          resolve(e.data.pdfBytes);
        } else {
          reject(new Error(e.data.message));
        }
      };

      const filesToMerge = [];
      const uniqueFileNames = new Set();
      
      // Extract unique files needed for the merge job
      jobs.forEach(job => uniqueFileNames.add(job.fileName));

      // Prepare file data
      for (const file of files) {
          if (uniqueFileNames.has(file.name)) {
              filesToMerge.push({
                  name: file.name,
                  data: file.data // Expecting ArrayBuffer here
              });
          }
      }

      const message = {
        command: 'merge',
        files: filesToMerge,
        jobs: jobs,
        cpdfUrl: process.env.PUBLIC_URL + '/coherentpdf.browser.min.js',
      };

      // Transferrable objects for performance
      const transferrables = filesToMerge.map(f => f.data);
      this.worker.postMessage(message, transferrables);
    });
  }
}

export const pdfMergeService = new PdfMergeService();
